var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-dimensions",style:({ padding: _vm.maxDimensionPx / 2 + 'px' })},[_c('div',{staticClass:"line"},[_vm._l((_vm.$ml.get('data')),function(datum){return _c('div',{key:datum.id,class:[
        'dot',
        {
          selected: _vm.getPaint.id === datum.id,
          extremity:
            datum.width * datum.height === _vm.minArea ||
            datum.width * datum.height === _vm.maxArea
        }
      ],style:({
        left: ("calc(" + (_vm.scaleArea(
          datum.shape === 'cerchio'
            ? datum.width * Math.PI
            : datum.width * datum.height
        )) + "% - 1.5px)")
      })},[(
          datum.width * datum.height === _vm.minArea ||
            datum.width * datum.height === _vm.maxArea
        )?_c('div',{staticClass:"reference-area",style:({
          width: _vm.scaleDimension(datum.width) + 'px',
          height: _vm.scaleDimension(datum.height) + 'px'
        })},[_c('div',{staticClass:"area-label"},[_vm._v("\n          "+_vm._s(datum.width)+"x"+_vm._s(datum.height)),_c('br'),_vm._v(_vm._s(datum.width * datum.height === _vm.minArea
              ? _vm.$ml.get("content").chart_dimension_first_label
              : _vm.$ml.get("content").chart_dimension_last_label)+"\n        ")])]):_vm._e()])}),_c('div',{class:['area', { circle: _vm.getPaint.shape === 'cerchio' }],style:({
        left: ("calc(" + (_vm.scaleArea(
          _vm.getPaint.shape === 'cerchio'
            ? _vm.getPaint.width * Math.PI
            : _vm.getPaint.width * _vm.getPaint.height
        )) + "% + 1.5px)"),
        width: _vm.scaleDimension(_vm.getPaint.width) + 'px',
        height: _vm.scaleDimension(_vm.getPaint.height) + 'px'
      })},[_c('div',{staticClass:"area-label"},[(_vm.getPaint.shape === 'cerchio')?[_vm._v(_vm._s(_vm.getPaint.width))]:[_vm._v("\n          "+_vm._s(_vm.getPaint.width)+"x"+_vm._s(_vm.getPaint.height))]],2)])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }